import familiadosApiClient from '$utils/familiadosApiClient'
import { Profile } from '$domain/model/caretaker/caretaker.model'
import { apiErrorService } from '$utils/services/apiErrorService'
import { profileModelToFormData } from './caretaker.mapper'

export const getProfilePath = '/caretaker/profile-data'
export const registerCaretakerPath = '/caretaker/register'

export const registerCaretaker = async (name: string, email: string, password: string) => {
  try {
    return await familiadosApiClient.post<{
      id: string
    }>(registerCaretakerPath, {
      name,
      email,
      password,
    })
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const getProfile = async () => {
  try {
    const profileModelData = await familiadosApiClient.get<Profile>(getProfilePath)
    return profileModelToFormData(profileModelData)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/caretaker.manager.ts